import { render, staticRenderFns } from "./RegisterVolunteer.vue?vue&type=template&id=4cf1aa85&scoped=true"
import script from "./RegisterVolunteer.vue?vue&type=script&lang=js"
export * from "./RegisterVolunteer.vue?vue&type=script&lang=js"
import style0 from "./RegisterVolunteer.vue?vue&type=style&index=0&id=4cf1aa85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1aa85",
  null
  
)

export default component.exports